export var config = {
  key:"insuide@wisefly<<>>p"
}


// WEBPACK FOOTER //
// ./src/app/services/encrypt/config.ts